<template>
  <n-modal v-bind="$props">
    <!-- prettier-ignore -->
    <Form ref="modalForm" :model="model" :label-width="labelWidth" class="n-modal-container" @submit.native.prevent>
      <Tabs type="card" name="modalLp" :animated="false">
        <TabPane tab="modalLp" name="basic" :label="this.$t('label.basic')" class="n-modal-container">
          <n-row-col2>
            <!-- id -->
            <n-field-id v-model="model.id" field-name="id" label="id" :error="error.id" :disabled="true" />
            <!-- companyId -->
            <n-field-selection v-model="model.companyId" field-name="companyId" selection-name="company.company" :error="error.companyId" label="company" :disabled="disabled"/>
          </n-row-col2>
          <n-row-col2>
            <!-- title -->
            <n-field-text v-model="model.title" field-name="title" label="title" :error="error.title" :disabled="disabled" />
            <!-- label -->
            <n-field-text v-model="model.label" field-name="label" label="label" :error="error.label" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- recommend -->
            <n-field-boolean v-model="model.recommend" label="recommend" :error="error.recommend" :disabled="disabled" />
            <!-- version -->
            <n-field-id v-model="model.version" label="version" disabled />
          </n-row-col2>
          <n-row-col2>
          <!-- iosStoreId -->
          <n-field-text v-model="model.iosStoreId" field-name="iosStoreId" label="iosStoreId" :error="error.iosStoreId" :disabled="disabled" />
          <!-- andStoreId -->
          <n-field-text v-model="model.andStoreId" field-name="andStoreId" label="andStoreId" :error="error.andStoreId" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- iosHeight -->
            <n-field-text v-model="model.iosHeight" field-name="iosHeight" label="iosHeight" :error="error.iosHeight" :disabled="disabled" />
            <!-- andHeight -->
            <n-field-text v-model="model.andHeight" field-name="andHeight" label="andHeight" :error="error.andHeight" :disabled="disabled" />
          </n-row-col2>
        </TabPane>
        <TabPane tab="modalLp" name="lightTheme" :label="this.$t('label.lightTheme')" class="n-modal-container">
          <n-row-col2>
            <n-field-boolean v-model="model.wysiwygLight" field-name="wysiwygLight" label="wysiwygLight" :error="error.wysiwygLight" :disabled="disabled" />
            <n-field-boolean v-model="model.previewLight" field-name="previewLight" label="previewLight" :error="error.previewLight" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- backgroundImageLight -->
            <n-field-text v-model="model.backgroundImageLight" field-name="backgroundImageLight" label="backgroundImageLight" :error="error.backgroundImageLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- descriptionLight -->
            <n-text-editor v-model="model.descriptionLight" :editor-height="150" :html="model.wysiwygLight" field-name="descriptionLight" label="description" :error="error.descriptionLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1 v-if="model.previewLight">
            <n-field-preview v-model="model.descriptionLight" field-name="previewLight" label="previewLight" :error="error.descriptionLight" :disabled="disabled" />
          </n-row-col1>
        </TabPane>
        <TabPane tab="modalLp" name="darkTheme" :label="this.$t('label.darkTheme')" class="n-modal-container">
          <n-row-col2>
            <n-field-boolean v-model="model.wysiwygDark" field-name="wysiwygDark" label="wysiwygDark" :error="error.wysiwygDark" :disabled="disabled" />
            <n-field-boolean v-model="model.previewDark" field-name="previewDark" label="previewDark" :error="error.previewDark" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- backgroundImageDark -->
            <n-field-text v-model="model.backgroundImageDark" field-name="backgroundImageDark" label="backgroundImageDark" :error="error.backgroundImageDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- descriptionDark -->
            <n-text-editor v-model="model.descriptionDark" :editor-height="150" :html="model.wysiwygDark" field-name="descriptionDark" label="description" :error="error.descriptionDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1 v-if="model.previewDark">
            <n-field-preview v-model="model.descriptionDark" field-name="previewDark" label="previewDark" :error="error.descriptionDark" :disabled="disabled" />
          </n-row-col1>
        </TabPane>
      </Tabs>
    </Form>
  </n-modal>
</template>
<script>
import { DATE_FORMAT } from '@/constant/format';
import NModal from '@/components/common/NModal';
import { add, edit, validate } from '@/api/company/company-lp-product';

export default NModal.extend({
  name: 'ModalCompanyLandingPageProduct',
  components: { NModal },

  data() {
    return {
      DATE_FORMAT,
    };
  },

  methods: {
    doSubmit(model) {
      return this.isEdit ? edit(model) : add(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },
});
</script>
